import React from 'react';

interface WelcomeModalProps {
  isVisible: boolean;
  onClose: () => void;
}

export function WelcomeModal({ isVisible, onClose }: WelcomeModalProps) {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 backdrop-blur-sm">
      <div className="bg-white rounded-2xl p-8 max-w-lg w-11/12 relative shadow-xl">
        <button 
          onClick={onClose}
          className="absolute right-4 top-4 text-gray-500 hover:text-gray-700 text-2xl"
        >
          &times;
        </button>
        
        <img 
          src="/pizza-marker.svg" 
          alt="Welcome to PizzaVeg"
          className="w-32 h-32 mx-auto mb-6"
        />
        
        <h2 className="text-2xl font-bold text-gray-800 mb-4 text-center">
          Benvenuto su PizzaVeg! 🌱
        </h2>
        
        <p className="text-gray-600 text-center mb-6">
          Scopri le migliori pizzerie con opzioni vegetariane e vegane nella tua zona.
          Ordina facilmente e goditi le tue pizze preferite!
        </p>

        <button
          onClick={onClose}
          className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-6 rounded-full transition-colors"
        >
          Inizia a Esplorare
        </button>
      </div>
    </div>
  );
} 